import * as angular from 'angular';

angular.module('app').controller('SearchHelpController', searchHelp);

function searchHelp($scope, searchHelpService) {
	searchHelpService.getSearchFieldsAsync().then(fields => {
		$scope.fields = fields;
	});
}
